export default __webpack_public_path__ + "static/media/icon_location.02659052.svg";